import ComplexExpressionButton from '../core/ComplexExpressionButton';
import RestrictionButton from '../core/RestrctionButton';
import PropTypes from 'prop-types';
import React from 'react';
import { Typography } from '@material-ui/core';
import Tooltip from '@material-ui/core/Tooltip';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import IconButton from '@material-ui/core/IconButton';

class AdvancedButtons extends React.Component {

    render() {

        const { property, onAddExpression, onAddRestriction, onAddSimple, title, dataTest } = this.props;

        return (
            <div style={{
                display: 'inline-block',
                border: 'solid 1px #97d700',
                backgroundColor: 'white',
                padding: '6px 16px',
                borderRadius: 6
            }}>
                <Typography variant="body2"
                    style={{
                        display: 'inline-block',
                        color: '#50832C',
                        fontWeight: 500,
                        fontSize: 16,
                        transform: 'translateY(1px)',
                        textTransform: 'uppercase'
                    }}>{title}</Typography>
                <span style={{ marginLeft: 12, whiteSpace: 'nowrap' }}>
                    {onAddRestriction &&
                        <span style={{ marginRight: 6 }}>
                            <RestrictionButton
                                dataTest={dataTest + "-restriction"}
                                onClick={onAddRestriction(property)}
                                title="Add a restriction" />
                        </span>
                    }
                    <span style={{ marginRight: 6 }}>
                        <ComplexExpressionButton
                            dataTest={"complex-" + dataTest}
                            onClick={onAddExpression(property)}
                            title="Add a complex class expression" />
                    </span>
                    <span>
                        <Tooltip title="Add a class">
                            <span>
                                <IconButton disabled={this.props.disabled} data-test={this.props.dataTest}
                                    size="small" onClick={onAddSimple(property)}>
                                    <AddCircleIcon />
                                </IconButton>
                            </span>
                        </Tooltip>
                    </span>
                </span>
            </div>
        );
    }
}

AdvancedButtons.defaultProps = {
    disabled: false
};

AdvancedButtons.propTypes = {
    dataTest: PropTypes.string,
    disabled: PropTypes.bool,
    property: PropTypes.string,
    onAddExpression: PropTypes.func,
    onAddRestriction: PropTypes.func,
    onAddSimple: PropTypes.func,
    title: PropTypes.string
};

export default AdvancedButtons;